module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jgSon"))).then(() => parcelRequire('jPBao'));